<p-card *ngFor="let group of groupedItems" [header]="group[0]">
  <div *ngIf="loading" class="centered">
    <i class="pi pi-spin pi-spinner"></i>
    Calculating...
  </div>
  <div *ngIf="group[1]" [formGroup]="authorizationNumbers">
    <p-table [value]="group[1]" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
            <th>Transfer</th>
            <th>To Amt</th>
            <th>Authorization Number</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
            <td>{{ getProduct(row.toProductId) | async }}</td>
            <td>{{ row.toTotal }}</td>
            <td>
              <div class="form-group">
                <input type="text" [formControlName]="row.id.toString()"/>
              </div>
              <error-block
                [field]="authorizationNumbers.get(row.id.toString())"
                [messages]="{
                  'required': 'Authorization # is required.',
                  'maxlength': 'Authorization # must be 20 characters or less.',
                  'authInUse': 'Auth # already used on another shift or load.',
                  'dupAuth': 'Cannot use auth # on multiple lines.'
                }"></error-block>
            </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr class="totals">
          <td>Total Transfers</td>
          <td>{{ sumTotal('toTotal', group[0]) }}</td>
          <td></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>

